import { styled } from "@mui/material";

export const Label = styled("span")(() => ({
  whiteSpace: "nowrap",
  overflow: "hidden",
}));
